import { api } from "@/config/api";
import * as Sentry from "@sentry/react-native";
import type { AxiosError } from "axios";

import { WelcomeFailReason } from "ipctg-inflow-types/InFlowEnums";
import type { ParkWelcomePOSTErrorResponse, ParkWelcomePOSTRequest, ParkWelcomePOSTSuccessResponse } from "ipctg-inflow-types/InFlowParkAPI";
import { Platform } from "react-native";

export const fetchWelcomeData = async (requestData: ParkWelcomePOSTRequest): Promise<ParkWelcomePOSTSuccessResponse> => {
  try {
    const response = await api.post<ParkWelcomePOSTSuccessResponse>("/welcome", requestData);
    return response.data;
  } catch (error) {
    Sentry.captureException(error, {
      extra: {
        data: requestData,
        localStorage: Platform.OS === "web" ? window.localStorage : null,
      },
    });
    const axiosError = error as AxiosError<ParkWelcomePOSTErrorResponse>;
    throw axiosError.response?.data ?? { failReason: WelcomeFailReason };
  }
};
